import request from '@/utils/request';
/**获取物料详情*/
export const materialDetails = function (id: any) {
  let url = `/api/MaterialOrder/${id}`;
  return request.get(url, {})
}

/* 审核通过 */
export const passMaterial = function (data: any) {
  let param = Object.assign({}, data);
  let url = '/api/MaterialOrder/ReviewOrder';
  return request
    .post(url, param)
}
/* 取消申请单 */
export const cancelMaterial = function (data: any) {
  let param = Object.assign({}, data);
  let url = '/api/MaterialOrder/Cancel';
  return request
    .post(url, param)
}

/*订单 待配货清单*/
export const pendingAllocation = function (id: any) {
  let url = `/api/MaterialOrder/${id}/pendingAllocation`;
  return request.get(url, {})
}
/*订单 已出库清单 */
export const stockList = function (id: any) {
  let url = `/api/MaterialOrder/${id}/stock`;
  return request.get(url, {})
}
//** 订单已发货清单*/ 
export const shippedList = function (id: any) {
  let url = `/api/MaterialOrder/${id}/shippedList`;
  return request.get(url, {})
}

/*确认领取*/
export const confirmReceiveShipment = function (id: any) {
  let url = `/api/Shipment/${id}/ReceiveShipment`;
  return request
    .post(url, {})
}
/*取消发放*/
export const confirmCancelGiveOut = function (id: any) {
  let url = `/api/Shipment/${id}/CancelGiveOut`;
  return request
    .post(url, {})
}

/**编辑或者新增物料申请单 */
export const addOrEditMaterials = function (form: any) {
  let param = Object.assign({}, form);
  let url = '/api/MaterialOrder/CreateOrEdit';
  return request
    .post(url, param)
}

/**物料申请单详情 */
export const getMaterialDetail = function (id: string) {
  const url = `/api/MaterialOrder/${id}`;
  return request.get(url)
}

/**取消物料申请单 */
export const cancelMaterials = function (form: any) {
  let param = Object.assign({}, form);
  const url = `/api/MaterialOrder/Cancel`;
  return request.post(url, param)
}
/*删除物料单 */
export const delMaterials = function (id: any) {
  const url = `/api/MaterialOrder/${id}`;
  return request.del(url)
}
